<app-confirmar-dialog-ui
  [loading]="loading"
  [modalTitle]="data?.modalTitle"
  [modalMessage]="data?.modalMessage"
  [warn]="data?.warn"
  [mainButtonName]="data?.mainButtonName"
  (confirm)="onSave()"
  (cancel)="onCancel()"
></app-confirmar-dialog-ui>
